import { Controller } from '@hotwired/stimulus'
import Imask from 'imask'

export default class ImaskController extends Controller {
  static values = { type: String }

  initialize () {
    switch (this.element.dataset.type) {
      case 'phone':
        Imask(this.element, {
          mask: '+1 (000) 000-0000',
          lazy: true,
          country: 'USA',
          blocks: {
            num: {
              mask: Number
            }
          }
        })
        break
      case 'digits':
        Imask(this.element, {
          mask: Number,
          min: 0
        })
    }
  }
}
